import React, {useState} from "react";

import "./ButtonGroup.css"
/***
 * No me convence la solucion, quiero buscar una mejor
 * en dhtmlx nos reprime mucho por lo que opte por hacer uno propio
 * tal vez lo mejor sea regresar a dhtmlx?
 */
const ButtonGroup = (props) => {
  
  const [clickedId, setClickedId] = useState(0);
  const handleClick = (event, id, value) => {
    if(!props.disable && !props.cargando){
      setClickedId(id);
      props.toogleAction(value);
    }
  };
  function getClassName (i){
    let clase = "customButton";
    if(props.disable || props.cargando){
      if(i === clickedId){
        clase = clase + " active-disable";
      }
      else{
        clase = clase + " disable";
      }
    }
    if(i === clickedId){
      clase = clase + " active";
    }
    return clase;
  }

  return (
    <>
      {props.buttons.map((buttonLabel, i) => (
        <button
          key={i}
          name={buttonLabel.id}
          onClick={(event) => handleClick(event, i, buttonLabel.id)}
          className={getClassName(i)}
        >
          {buttonLabel.value}
        </button>
      ))}
    </>
  );
};
export default ButtonGroup;